<script setup lang="ts">
const { t, tm, rt } = useI18n();
const site = useSiteData();
const { localized } = useLocaleValue();
const effectiveDate = "2025-12-01";
const tmList = (key: string) => tm(key) as unknown[];
const tmHtml = (item: unknown) => rt(item as Parameters<typeof rt>[0]);

definePageMeta({
  page_name: "terms",
  robots: "noindex, follow",
});
</script>

<template>
  <section class="page-header">
    <div class="container">
      <h1>{{ t("terms.header.title") }}</h1>
    </div>
  </section>

  <section class="about-content">
    <div class="container">
      <div class="about-section">
        <p>
          <strong>{{ t("terms.effective_date_label") }}</strong>
          {{ effectiveDate }}
        </p>
        <p>
          {{ t("terms.intro.prefix") }}
          <strong>{{ localized(site.company_full_legal_name) }}</strong>
          {{ t("terms.intro.suffix") }}
        </p>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.acceptance.title") }}</h2>
        <p>{{ t("terms.sections.acceptance.body") }}</p>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.use.title") }}</h2>
        <ul class="privacy-list">
          <li
            v-for="(item, index) in tmList('terms.sections.use.items')"
            :key="index"
            v-html="tmHtml(item)"
          />
        </ul>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.ip.title") }}</h2>
        <ul class="privacy-list">
          <li
            v-for="(item, index) in tmList('terms.sections.ip.items')"
            :key="index"
            v-html="tmHtml(item)"
          />
        </ul>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.liability.title") }}</h2>
        <ul class="privacy-list">
          <li
            v-for="(item, index) in tmList('terms.sections.liability.items')"
            :key="index"
            v-html="tmHtml(item)"
          />
        </ul>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.external_links.title") }}</h2>
        <ul class="privacy-list">
          <li
            v-for="(item, index) in tmList('terms.sections.external_links.items')"
            :key="index"
            v-html="tmHtml(item)"
          />
        </ul>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.privacy.title") }}</h2>
        <p>
          {{ t("terms.sections.privacy.prefix") }}
          <NuxtLink to="/privacy-policy">
            <strong>{{ t("terms.sections.privacy.link_label") }}</strong>
          </NuxtLink>
          {{ t("terms.sections.privacy.suffix") }}
        </p>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.governing_law.title") }}</h2>
        <ul class="privacy-list">
          <li
            v-for="(item, index) in tmList('terms.sections.governing_law.items')"
            :key="index"
            v-html="tmHtml(item)"
          />
        </ul>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.changes.title") }}</h2>
        <ul class="privacy-list">
          <li
            v-for="(item, index) in tmList('terms.sections.changes.items')"
            :key="index"
            v-html="tmHtml(item)"
          />
        </ul>
      </div>

      <div class="about-section">
        <h2>{{ t("terms.sections.contact.title") }}</h2>
        <p>{{ t("terms.sections.contact.intro") }}</p>
        <p>
          <strong>{{ localized(site.company_full_legal_name) }}</strong><br />
          {{
            localized(site.legal_address.building_number)
          }}
          {{
            localized(site.legal_address.street_name)
          }}{{ t("common.comma") }}
          {{
            localized(site.legal_address.additional_number)
          }}
          {{
            localized(site.legal_address.district)
          }}{{ t("common.comma") }}
          {{
            localized(site.legal_address.postal_code)
          }}
          {{
            localized(site.legal_address.city)
          }}{{ t("common.comma") }}
          {{ localized(site.legal_address.country) }}<br />
          {{ t("terms.sections.contact.email_label") }}
          <a :href="`mailto:${localized(site.official_email)}`">
            {{ localized(site.official_email) }}
          </a>
        </p>
        <p>
          {{ t("terms.sections.contact.footer_prefix") }}
          <NuxtLink to="/contact">
            {{ t("terms.sections.contact.contact_link_label") }}
          </NuxtLink>.
        </p>
      </div>
    </div>
  </section>
</template>

